export enum ChartTypes {
  LINE = 'line',
  BAR = 'bar'
}